import React, { useState, useEffect, useContext, useRef } from "react";
import formValidation from "../validations/es6/core/Core";
import {
  Form,
  Input,
  FormGroup,
  Label,
  Alert,
  Button,
  CustomInput,
  FormText,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader
} from "reactstrap";
import Select from "react-select";
import axios from "axios";
import { StateContext } from "../utils/context";
import { createValidationOptions } from "./Profile/profileValidation";
import vat from "../components/Profile/customVatValidator";
import iban from "../validations/es6/validators/iban";
import { useTranslation } from "react-i18next";
import { getCookie } from "../jwt/_helpers/cookie";
import Countries from "../utils/countriesExtended.json";

const API_URL = process.env.REACT_APP_API_URL_BASE;
const X_API_KEY = process.env.REACT_APP_X_API_KEY;

const euCountryCodes = ["AT", "BE", "BG", "CY", "CZ", "DE", "DK", "EE", "EL", "ES", "FI", "FR", "HR", "HU", "IE", "IT", "LT", "LU", "LV", "MT", "NL", "PL", "PT", "RO", "SE", "SI", "SK", "GB", "GR"];

const isAnEuCountry = (countryCode) => {
  countryCode = countryCode.toUpperCase();
  return euCountryCodes.includes(countryCode);
};

const ProfileForm = ({ data, isBlacklisted }) => {
  const { t, i18n } = useTranslation();
  const { setCurrentUser } = useContext(StateContext);
  const stateRef = useRef();
  const initVal = data;
  const token = getCookie("token");
  //ajax handlers
  const [success, setSuccess] = useState(false);
  const [errorPut, setError] = useState(false);

  //Validation
  const [country, setCountry] = useState(false);
  const [prefMethod, setPrefMethod] = useState(null);
  const [profileURL, setProfileURL] = useState(null);

  const [vatCountryCode, setVATCountryCode] = useState("")

  const [openModal, setToggleModal] = useState(false);
  const [dataModal, setDataModal] = useState(null);

  const [lang, setLang] = useState(i18n.language);
  const [opt, setOpt] = useState(createValidationOptions(lang));

  const preferedMethodArr = [
    { label: t("profile.edit.form.option.preferedMethod.paypal"), value: 0 },
    { label: t("profile.edit.form.option.preferedMethod.bankAccount"), value: 1 }
  ];

  stateRef.current = profileURL;
  useEffect(() => {
    if (typeof initVal.preferred_payment_method !== 'undefined') {
      setPrefMethod(
        preferedMethodArr.filter(
          i => i.value === initVal.preferred_payment_method
        )[0]
      );
    }
  }, [initVal.preferred_payment_method]);

  useEffect(() => {
    setLang(i18n.language);
  }, [i18n.language]);

  useEffect(() => {
    setOpt(createValidationOptions(lang));
  }, [lang]);

  useEffect(() => {
    if (initVal.country) {
      setCountry(Countries.filter(i => i.value === initVal.country));
      setVATCountryCode(initVal.country);
    }
  }, [initVal.country]);

  useEffect(() => {
    var formID = document.getElementById("editProfileForm");
    const fv = formValidation(formID, opt)
      .on("core.validator.validating", function(e) {})
      .on("core.validator.validated", function(e) {
        const item = e.field;
        if (item === 'profile_image' && e.result.valid) {
          const file = e.element.files[0];
          handleIMG_AWS(file);
        }
      })
      .on("core.validator.validated", function(e) {
        const item = e.field;
        if (item === 'logo' && e.result.valid) {
          const file = e.element.files[0];
          handleIMG_AWS(file, 'media/linklandingpage_logos/', 'logo');
        }
        if (item === 'background_image' && e.result.valid) {
          const file = e.element.files[0];
          handleIMG_AWS(file, 'media/linklandingpage_bg_images/', 'bgImage');
        }
        if (!e.result.valid) {
          const messages = [].slice.call(formID.querySelectorAll('[data-field="' + e.field + '"][data-validator]'));
          for(let i = 0; i < messages.length - 1; i++) {
            const messageEle = messages[i];
            messageEle.style.display = 'none';
          }
        }
      })
      .on("core.form.valid", e => {
        const getData = inputName => formID.querySelector(`[name="${inputName}"]`).value;
        const checkData = (name, newVal) => (name !== newVal ? true : false);

        let formData = new FormData();
        stateRef.current && formData.append("profile_image", stateRef.current);

        if(!initVal.basic_info_submitted) {
          checkData(initVal.street_and_number, getData("street_and_number")) &&
          formData.append("street_and_number", getData("street_and_number"));

          checkData(initVal.postal_code, getData("postal_code")) &&
          formData.append("postal_code", getData("postal_code"));

          checkData(initVal.city, getData("city")) &&
          formData.append("city", getData("city"));

          checkData(initVal.country, getData("country")) &&
          formData.append("country", getData("country"));
        }

        if(isAnEuCountry(vatCountryCode) && !initVal.basic_info_submitted && initVal.can_edit_vat_number)
        {
          checkData(initVal.vat, getData("vatNumber")) &&
          formData.append("vat", getData("vatNumber"));
        }

        checkData(initVal.paypal_email, getData("paypal_email")) &&
        formData.append("paypal_email", getData("paypal_email"));

        checkData(initVal.account_holder_name, getData("account_holder_name")) &&
        formData.append("account_holder_name", getData("account_holder_name"));

        checkData(initVal.bank_name, getData("bank_name")) &&
        formData.append("bank_name", getData("bank_name"));

        checkData(initVal.preferred_payment_method, getData("preferred_payment_method")) &&
        formData.append("preferred_payment_method", getData("preferred_payment_method"));

        checkData(initVal.iban, getData("iban")) &&
        formData.append("iban", getData("iban"));

        setDataModal(formData);
        setToggleModal(true);
        
      });
      
    fv.registerValidator("vat", vat);
    fv.registerValidator("iban", iban);
  }, [opt, lang]);


  const handleSubmit = () => {
    axios({
      method: "PATCH",
      url: `${API_URL}users/${initVal.id}/`,
      data: dataModal,
      mode: 'cors',
      headers: {
        Authorization: `Bearer ${token}`,
        "x-api-key": X_API_KEY,
      }
    }).then(function(response) {
      if (response.status === 200) {
        axios({
          method: "GET",
          url: `${API_URL}users/${initVal.id}/`,
          data: dataModal,
          mode: 'cors',
          headers: {
            Authorization: `Bearer ${token}`,
            "x-api-key": X_API_KEY,
          }
        }).then(function(response) {
          if (response.status === 200){
            setCurrentUser(response.data);
            setSuccess(true);
            setToggleModal(false)
          }
          
        });
       
      } else {
        setToggleModal(false);
        setError(true);
      }
    });
  }

  const generateRandomHex = (length) => {
    return [...Array(length)]
    .map(() => Math.floor(Math.random() * 16).toString(16))
    .join('');
  }

  const handleIMG_AWS = (file) => {
    let fileParts = file.name;
    const fileName = generateRandomHex(10);
    let fileType = fileParts.split('.')[1]

    axios({
      method: "GET",
      mode: 'cors',
      url: `${API_URL}obtain-signed-url-for-upload/?filename=media/users/profile_images/${fileName}.${fileType}&filetype=${fileType}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "x-api-key": X_API_KEY,
      }
    }).then(function(response) {


      const URL = response.data.signed_url.url;
      const full_URL= response.data.signed_url.fields.key;
      let split = full_URL.split('/');
      split.shift();
      let transformedURL = split.join('/');

      const signedOpts = response.data.signed_url.fields;
      var options = {
        mode: 'cors',
        headers: {
          "Content-Type": fileType
        }
      };
      var postData = new FormData();
      for (let i in signedOpts) {
        postData.append(i, signedOpts[i]);
      }
      postData.append("file", file);

      axios
        .post(URL, postData, options)
        .then(result => {
          setProfileURL(transformedURL);
        })
        .catch(error => {
          console.log("ERROR " + error);
        });
    })
  }

  return (
    <>
      <Form id="editProfileForm">
        <FormGroup>
          <Label for="image">{t("profile.edit.form.label.profileImage")}</Label>
          <CustomInput
            type="file"
            id="image"
            name="profile_image"
            accept=".jpeg,.jpg"
          />
          <FormText color="muted">
            {t("profile.edit.form.help_text.profileImage")}
          </FormText>
        </FormGroup>
        <FormGroup>
          <Label>{t("profile.edit.form.label.streetAndNumber")}</Label>
          <Input
            name="street_and_number"
            type="text"
            className="form-control"
            disabled={!initVal.basic_info_submitted ? false : true}
            defaultValue={initVal.street_and_number}
          />
        </FormGroup>
        <FormGroup>
          <Label>{t("profile.edit.form.label.postalCode")}</Label>
          <Input
            name="postal_code"
            type="text"
            className="form-control"
            disabled={!initVal.basic_info_submitted ? false : true}
            defaultValue={initVal.postal_code}
          />
        </FormGroup>
        <FormGroup>
          <Label>{t("profile.edit.form.label.city")}</Label>
          <Input
            name="city"
            type="text"
            className="form-control"
            disabled={!initVal.basic_info_submitted ? false : true}
            defaultValue={initVal.city}
          />
        </FormGroup>
        <FormGroup>
          <Label>{t("profile.edit.form.label.country")}</Label>
          <Select
            components={{ IndicatorSeparator:() => null }}
            name="country"
            options={Countries}
            value={country}
            onChange={e => {
              setCountry(e);
              setVATCountryCode(e.value);
            }}
            isDisabled={!initVal.basic_info_submitted ? false : true}
          />
        </FormGroup>
        <FormGroup>
          <Label>{t("profile.edit.form.label.vatNumber")}</Label>
          <Input
            name="vatNumber"
            type="text"
            disabled={!isAnEuCountry(vatCountryCode) || initVal.basic_info_submitted || !initVal.can_edit_vat_number}
            className="form-control"
            defaultValue={isAnEuCountry(vatCountryCode) ? initVal.vat: ""}
          />
        </FormGroup>
        <FormGroup>
          <Label>{t("profile.edit.form.label.nationalTaxNumber")}</Label>
          <Input
            name="nationalTaxNumber"
            type="text"
            disabled={true}
            className="form-control"
            defaultValue={initVal.national_tax_number}
          />
        </FormGroup>
        <FormGroup>
          <Label>{t("profile.edit.form.label.businessRegistrationNumber")}</Label>
          <Input
            name="businessRegistrationNumber"
            type="text"
            disabled={true}
            className="form-control"
            defaultValue={initVal.business_reg_number}
          />
        </FormGroup>
        <FormGroup>
          <Label>{t("profile.edit.form.label.vatStatus")}</Label>
          <Input
            name="vatStatus"
            type="text"
            disabled={true}
            className="form-control"
            defaultValue={initVal.vat_status}
          />
        </FormGroup>
        <FormGroup>
          <Label>{t("profile.edit.form.label.businessType")}</Label>
          <Input
            name="businessType"
            type="text"
            disabled={true}
            className="form-control"
            defaultValue={initVal.business_type_long}
          />
        </FormGroup>

        <FormGroup>
          { initVal.vat_exempt && 
            <div>
              <Label>{t("profile.edit.form.label.vatExemptDocument")}</Label>&nbsp;
              <i className="fas fa-check-circle fa-lg text-success"></i>
            </div>        
          }
        </FormGroup>

        <FormGroup>
          { initVal.business_certificate && 
            <div>
              <Label>{t("profile.edit.form.label.businessCertificate")}</Label>&nbsp;
              <i className="fas fa-check-circle fa-lg text-success"></i>
            </div>        
          }
        </FormGroup>

        <FormGroup>
          <Label for="preferred_payment_method">{t("profile.edit.form.label.preferredPaymentMethod")}</Label>
          <Select
            components={{ IndicatorSeparator:() => null }}
            name="preferred_payment_method"
            options={preferedMethodArr}
            value={prefMethod}
            onChange={e => setPrefMethod(e)}
          />
        </FormGroup>
        <FormGroup>
          <Label>{t("profile.edit.form.label.paypalEmail")}</Label>
          <Input
            name="paypal_email"
            type="email"
            className="form-control"
            defaultValue={initVal.paypal_email}
            disabled={prefMethod ? prefMethod.value === 0 ? false : true : true}
          />
        </FormGroup>
        <FormGroup>
          <Label>{t("profile.edit.form.label.accountHolderName")}</Label>
          <Input
            name="account_holder_name"
            type="text"
            className="form-control"
            defaultValue={initVal.account_holder_name}
            disabled={prefMethod ? prefMethod.value === 1 ? false : true : true}
          />
        </FormGroup>
        <FormGroup>
          <Label>{t("profile.edit.form.label.bankName")}</Label>
          <Input
            name="bank_name"
            type="text"
            className="form-control"
            defaultValue={initVal.bank_name}
            disabled={prefMethod ? prefMethod.value === 1 ? false : true : true}
          />
        </FormGroup>
        <FormGroup>
          <Label>{t("profile.edit.form.label.bankAddress")}</Label>
          <Input
            name="bank_address"
            type="text"
            className="form-control"
            defaultValue={initVal.bank_address}
            disabled={prefMethod ? prefMethod.value === 1 ? false : true : true}
          />
        </FormGroup>
        
        <FormGroup>
          <Label>{t("profile.edit.form.label.iban")}</Label>
          <Input
            name="iban"
            type="text"
            className="form-control"
            defaultValue={initVal.iban}
            disabled={prefMethod ? prefMethod.value === 1 ? country ? false : true : true : true}
          />
          <FormText color="muted">
            {t("profile.edit.form.help_text.iban")}
          </FormText>
        </FormGroup>
        <Button color="success" type="submit" disabled={data.is_blacklisted}>
          {t("profile.edit.form.button.submit")}
        </Button>
      </Form>
      <div style={{ paddingTop: "30px" }}>
        {success && (
          <Alert color="success">{t("profile.edit.message.success")}</Alert>
        )}
        {errorPut && (
          <Alert color="danger">
            {t("profile.edit.message.error")}
          </Alert>
        )}
      </div>
      {openModal && (
        <Modal isOpen={openModal} centered={true}>
        <ModalHeader>{t("profile.edit.modal.header")}</ModalHeader>
        <ModalBody>{t("profile.edit.modal.body")}</ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setToggleModal(false)}>
            {t("profile.edit.modal.button.cancel")}
          </Button>
          <Button color="success" onClick={() => handleSubmit()}>
            {t("profile.edit.modal.button.confirm")}
          </Button>
        </ModalFooter>
      </Modal>
      )}
    </>
  );
};

export default ProfileForm;
